import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {WorkingObjectsStatusesProvider} from '@providers/working-objects-statuses/working-objects-statuses.provider';
import {SelectValueInterface} from '@interfaces/select-value.interface';
import {FiltersComponent} from '@abstract/filters.component';
import {WorkingObjectPagesService} from '../../services/working-object-pages.service';

@Component({
    selector: 'app-working-objects-filters',
    templateUrl: 'working-objects-filters.component.html'
})

export class WorkingObjectsFiltersComponent extends FiltersComponent implements OnInit {

    form = this.fb.group({
        title: [''],
        org_customer: [''],
        status: ['']
    });

    statuses: SelectValueInterface[] = [
        {
            id: '',
            title: 'Все объекты'
        }
    ];

    constructor(
        service: WorkingObjectPagesService,
        public objectStatusesProvider: WorkingObjectsStatusesProvider,
        private fb: FormBuilder
    ) {
        super(service);
    }

    ngOnInit() {
        super.ngOnInit();
        this.statuses = this.statuses.concat(this.objectStatusesProvider.data$.getValue());
    }
}
